"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMegafootState = void 0;
var MegafootTranslate_init_1 = require("@/pages/common/states/MegafootTranslate.init");
exports.defaultMegafootState = {
    copyrightYear: 2022,
    subscribeEmail: '',
    subscribeIsLoading: false,
    linkAndroidApp: 'https://play.google.com/store/apps/details?id=com.okay.mobile',
    linkIosApp: 'https://apps.apple.com/app/okay-com-hk-property-agent/id1466195671',
    linkFacebook: 'https://www.facebook.com/OKAYDOTCOM',
    linkInstagram: 'https://www.instagram.com/okay.comhk/',
    linkLinkedIn: 'https://www.linkedin.com/company/okay-com',
    linkYoutube: 'https://www.youtube.com/user/okayproperty',
    t: MegafootTranslate_init_1.defaultMegafootTranslate,
};
